<template>
  <div class="v-contanier">
    <div class="faelists" v-if="hasNumber">

        <div class="sleepContentView" v-for="(item,index) in cdata" :key="index" v-if="index<3">
          <div class="circle"></div>
          <div class="item-circle">
            <div class="fea-count">{{ item.TOP_TIME }}<span>h</span></div>
            <div class="fea-name">{{ item.NAME || item.DEPT_NAME }}</div>
          </div>
        </div>

    </div>
    <noData v-else :mes="'暂无数据'"></noData>

    <!--<div class="fae-item" v-for="(item,index) in data" :key="index" v-if="index<showNumber">
      <div class="fae-info-b">
        <div class="fae-info">
          <span class="fae-no">No.{{ index + 1 }}</span>
          <span class="fea-name">{{ item.NAME || item.DEPT_NAME }}</span>
        </div>
        <div class="fea-count">{{ item.TOP_TIME }}<span>h</span></div>
      </div>
    </div>-->
  </div>
</template>

<script>
import noData from "@/view/schedule/components/noData";

export default {
  name: "rankTime",
  props: {
    cdata: Array,
    showNumber: Number
  },
  components: {noData},
  data() {
    return {
      hasNumber: false, // 是否有数据
    }
  },
  watch: {
    'cdata': function (newval) {
      if (newval && newval.length > 0) {
        this.hasNumber = true
      } else {
        this.hasNumber = false
      }
    }
  },
}
</script>

<style scoped lang="less">
// @import "../../../assets/css/base.less";

.sleepContentView {
  width: 100px;
  height: 100px;
  padding: 5px;
  background-image: linear-gradient(#aaf0d8, #2ED);
  border-radius: 50%;
  text-align: center;
  box-sizing: border-box;
  position: relative;
  /*margin-right: 20px;*/
}

.sleepContentView .circle {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 50%;
}

.faelists {
  padding: 10px 20px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;


  .fae-item {
    padding-bottom: 14px;
    margin-right: 20px;


    /deep/ .van-progress {
      background: none;
    }

    /deep/ .van-progress::after {
      position: absolute;
      content: '';
      bottom: -2px;
      left: 0;
      height: 1px;
      width: 100%;
      background: #2196f3;
    }

    /deep/ .van-progress__pivot {
      display: none;
    }

    /deep/ .van-progress__portion {
      background: #2196f3;
      border-radius: 0;
    }

    .fae-info-b {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      line-height: 1.8;
      font-size: 14px;

      .fae-no {
        color: #2196f3;
        margin-right: 8px;
        font-weight: bold;
      }

      .fea-name {
        margin-right: 8px;
      }

      .fea-dept {
        font-size: 12px;
      }

      .fea-count {
        font-weight: bold;
      }
    }

  }


  .item-circle {
    position: absolute;
    left: 0;
    top: 0;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .fea-count {
      font-size: 18px;
      font-weight: bold;
      color: @lightbule;
    }

    .fea-name {
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: 5px;
    }
  }
}

</style>